module.exports = __webpack_public_path__ + "img/sycxz.72f0dfcc.png";